'use client';

export { default } from './Typography';
export * from './TypographyProps';
export { default as typographyClasses } from './typographyClasses';
export * from './typographyClasses';